/* Common Imports */

import makeStyles from "@material-ui/core/styles/makeStyles";
import { withRouter } from "next/router";
import React from "react";

/* Component Imports */

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import NavDropdownItem from "./NavDropdownMenuItem";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "fit-content",
    display: "inline-block",
  },
  navButtonActive: {
    borderBottomStyle: "solid",
    borderWidth: "0px 0px 3px 0px",
    borderImage: "-webkit-linear-gradient(180deg, #08A945 0%, #0FCA56 100%) 1",
    padding: "1.5rem 1rem 1.3rem 0rem",
    borderRadius: 0,
    color: "#08A945",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1rem",
    letterSpacing: "0.047rem",
    textTransform: "capitalize",
    letterSpacing: "0.047rem",
  },
  navButton: {
    color: "#666666",
    borderBottom: "solid 3px #FFFFFF",
    padding: "1.5rem 1rem 1.3rem 1rem",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1rem",
    letterSpacing: "0.047rem",
    textTransform: "capitalize",
  },
  menu: {
    borderRadius: "5px",
    marginTop: "0.1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
    "& .MuiList-padding": {
      padding: 0,
    },
  },
  menuItem: {
    width: "10rem",
    padding: "0rem",
    "&:hover": {
      background: "#f1f1f1",
    },
  },
  btnText: {
    marginLeft: "1rem",
  },
  groupHeading: {
    margin: "0rem 0rem 0rem 0.5rem",
    lineHeight: "1.5rem",
  },
}));

const DispenseIcon = (iconString) => {
  switch (iconString) {
    case "navbar/company/active":
      return "/images/icons/nav/company-red.svg";
    case "navbar/arrowdown":
      return "/images/icons/nav/arrowdown.svg";
    case "navbar/arrowdown/active":
      return "/images/icons/nav/arrowdown-green.svg";
    default:
      return "/images/icons/nav/company-red.svg";
  }
};

const NavDropdownMenuProjects = (props) => {
  const classes = useStyles();
  const iconColor = props.router.pathname === "/eden" || props.router.pathname === "/halcyon" ? "active" : "inactive";

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <div className={classes.container}>
        <Button
          aria-controls="projects-menu"
          aria-haspopup="true"
          onClick={handleClick}
          className={
            props.router.pathname === "/eden" || props.router.pathname === "/halcyon"
              ? classes.navButtonActive
              : classes.navButton
          }
        >
          {/* Button Text */}

          <span className={classes.btnText}>{props.text}</span>

          {/* Arrow Down Icon */}

          <img
            alt={AppConfig.imageAltText}
            loading="eager"
            referrerPolicy="no-referrer"
            height={13}
            width={13}
            style={{ marginRight: "0rem", marginLeft: "0.7rem" }}
            src={DispenseIcon(iconColor == "inactive" ? "navbar/arrowdown" : "navbar/arrowdown/active")}
          />
        </Button>

        {/* Menu */}

        <Menu
          disableScrollLock
          id="projects-menu"
          className={classes.menu}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          keepMounted
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <Typography
            variant="body1"
            className={classes.groupHeading}
            style={{ margin: "0.5rem 0rem 0rem 0.5rem" }}
          >
            Ongoing
          </Typography>
          <MenuItem className={classes.menuItem}>
            <NavDropdownItem
              href="/eden"
              text="Heavie Eden"
            />
          </MenuItem>

          {/* <Typography variant="body1" className={classes.groupHeading}>
            Upcoming
          </Typography> */}
          <MenuItem
            className={classes.menuItem}
            style={{ margin: "0rem 0rem 0.5rem 0rem" }}
          >
            <NavDropdownItem
              href="/halcyon"
              text="Heavie Halcyon"
            />
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
};

export default withRouter(NavDropdownMenuProjects);
